import { memo } from 'react';
import { handleDomBubbleEvent } from '@/utils/dom';
import {
  ModalCloseButton,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalFooter,
  ModalConfirmButton,
} from '@/components/_ui/modal';
import { Spinner } from '@/components/_ui/spinner';
import Banner from '@/components/ui/banner';
import { TriangleAlert } from 'lucide-react';
import { BANNER_TITLE, DESCRIPTION } from './delete-ticket-modal.constant';
import { useDeleteTicketModal } from './use-delete-ticket-modal';

export type TDeleteTicketModalType = 'DeleteTicketModal';
export interface IDeleteTicketModalProps {
  spaceId: string;
  ticketId: string;
}
const DeleteTicketModal = memo(({ spaceId, ticketId }: IDeleteTicketModalProps) => {
  const {
    // Form
    form,

    // Modal
    isOpen,

    // Helpers
    isDisabledForm,
    isLoadingForm,

    // Handlers
    handleCloseModal,
    handleCancelModal,
    handleSubmitForm,
  } = useDeleteTicketModal({
    spaceId,
    ticketId,
  });

  // RENDER
  return (
    <Modal
      isOpen={isOpen}
      lockBodyScroll
      onClose={handleCloseModal}
      isCloseOutside={false}
      className="md:w-[430px] w-[345px] p-[32px]"
    >
      <ModalHeader>
        <ModalTitle>Delete Ticket</ModalTitle>
      </ModalHeader>
      <ModalContent>
        <form
          onSubmit={(e) => {
            handleDomBubbleEvent(e);
            form.handleSubmit(handleSubmitForm)(e);
          }}
          id="delete-ticketing-ticket-form"
          className="grid gap-[4px]"
        >
          <Banner className="my-[8px]" icon={TriangleAlert} title={BANNER_TITLE} variant="warning" />
          <div className="text-[14px] font-normal text-[#9D9D9C]">{DESCRIPTION}</div>
        </form>
      </ModalContent>
      <ModalFooter>
        <ModalCloseButton
          onClick={(e) => {
            handleDomBubbleEvent(e);
            handleCancelModal();
          }}
        >
          Cancel
        </ModalCloseButton>
        <ModalConfirmButton form="delete-ticketing-ticket-form" type="submit" disabled={isDisabledForm}>
          {isLoadingForm ? <Spinner isLoading={true} className="w-[18px] h-[18px]" /> : null} Delete
        </ModalConfirmButton>
      </ModalFooter>
    </Modal>
  );
});
DeleteTicketModal.displayName = 'DeleteTicketModal';
export default DeleteTicketModal;
